/** On-chain leftover from the DGC-era genesis ceremony (`CPC genesis validator N`). */

const CPC_GENESIS_DESC = /\bCPC genesis validator\b/gi;
const CPC_PREFIX = /^CPC\s+/i;
const GENERIC_VAL_NAME = /^validator-(\d+)$/i;

export function displayValidatorName(name: string | null | undefined): string {
	const s = (name ?? '').trim();
	if (!s) return '';
	return s.replace(CPC_GENESIS_DESC, 'RWAX genesis validator').replace(CPC_PREFIX, 'RWAX ');
}

export function displayValidatorDescription(description: string | null | undefined): string {
	return displayValidatorName(description);
}

/** Prefer remapped genesis description over bare `validator-N`. */
export function displayValidatorHeading(
	name: string | null | undefined,
	description?: string | null,
): string {
	const n = displayValidatorName(name);
	const d = displayValidatorDescription(description);
	const generic = n.match(GENERIC_VAL_NAME);
	if (generic && /RWAX genesis validator/i.test(d)) {
		return d;
	}
	if (generic) {
		return `RWAX genesis validator ${generic[1]}`;
	}
	return n || d;
}
